import styled, { css } from 'styled-components';

import { TAlertTypes } from '@r1-frontend/ui-react/components/Alert/TAlertTypes';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { IndentContainer, ListContainer, RounderContainer } from '@r1-frontend/ui-react/experimental/containers';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { BoxShadow } from '@r1-frontend/ui-react/tokens/boxShadow';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

const getIconBackgroundByType = (type: TAlertTypes): COLORS => {
    switch (type) {
        case 'info': {
            return COLORS.Outline_Dark;
        }
        case 'success': {
            return COLORS.Success;
        }
        case 'error': {
            return COLORS.Error;
        }
        default: {
            return COLORS.Outline_Dark;
        }
    }
};

export const AlertIcon = styled.div`
    width: 24px;
    height: 24px;
`;

export const AlertButtons = styled.div`
    @media(max-width: ${wideBreakpoints.mobile}) {
        button,
        ${ListContainer},
        ${IndentContainer} {
            width: 100%;
        }
    }
`;

export const Alert = styled(RounderContainer)<{
    background: COLORS,
    type: TAlertTypes,
    withShadow: boolean,
}>`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    max-width: 100%;
    align-items: center;
    padding: 16px;
    color: ${COLORS.TextPrimary};
    background-color: ${({ background }) => background};

    ${({ withShadow }) => withShadow && css`
        box-shadow: ${BoxShadow.S};
    `};

    & > button,
    & > ${AlertButtons} {
        margin-left: auto;
    }

    & > ${ListContainer} {
        align-items: center;
        flex-wrap: nowrap;
    }
     
    ${AlertIcon} {
        align-self: flex-start;

        /**
         * ad-hoc
         * TODO по дизайну типа transparent больше нет
         * Убрать после решения в какой из новых типов его перенести
         */
        ${({ type }) => type !== 'transparent' && css`
            & > svg {
                fill: ${getIconBackgroundByType(type)};
        
                #contour {
                    stroke: transparent; 
                }

                #guts { 
                    stroke: ${COLORS.TextWhite}; 
                }
            }
        `}
    }

    @media(max-width: ${wideBreakpoints.mobile}) {
        /**
         * Using block instead of grid to display properly in Safari
         */
        display: block;
        border-radius: ${BorderRadius.InnerBlockRadius};

        & > button {
            margin-top: 12px;
        }

        & > button,
        & > ${AlertButtons} {
            width: 100%;
        }
    }
`;
